import EventHandler, { GAME_EVENT } from "./EventHandler";
var PauseHandler = /** @class */ (function () {
    function PauseHandler() {
        var _this = this;
        this.prevSettingsData = { audio: null, sfx: null };
        var eventHandler = EventHandler.getInstance();
        eventHandler.on(GAME_EVENT.PAUSE, function () { return _this.pause(); }, true);
        eventHandler.on(GAME_EVENT.RESUME, function () { return _this.resume(); }, true);
    }
    PauseHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new PauseHandler();
        }
        return this._instance;
    };
    PauseHandler.prototype.updateSettings = function (mute) {
        if (!mute) {
            // load settings
            this.settingsData.audio = this.prevSettingsData.audio;
            this.settingsData.sfx = this.prevSettingsData.sfx;
            // reset prev settings
            this.prevSettingsData.audio = null;
            this.prevSettingsData.sfx = null;
            return;
        }
        // save settings as prev
        this.prevSettingsData.audio = this.settingsData.audio;
        this.prevSettingsData.sfx = this.settingsData.sfx;
        // update settings
        this.settingsData.audio = false;
        this.settingsData.sfx = false;
    };
    PauseHandler.prototype.load = function () { };
    PauseHandler.prototype.set = function (obj, settingsData) {
        this.obj = obj;
        this.settingsData = settingsData;
    };
    PauseHandler.prototype.pause = function () {
        console.log("[splash][pause-handler]", "pause");
        this.obj.pause();
        this.updateSettings(true);
    };
    PauseHandler.prototype.resume = function () {
        console.log("[splash][pause-handler]", "resume");
        this.obj.resume();
        this.updateSettings(false);
    };
    return PauseHandler;
}());
export default PauseHandler;
